import { Box, Fade, Stack } from "@mui/material";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Outlet, useLocation } from "react-router-dom";
import Aos from "../../components/Aos";
import CartModal from "../../components/CartModal/CartModal";
import Footer from "../../components/Footer/Footer";
import PopUp from "../../components/PopUp/PopUp";
import RequestOrder from "../../components/RequestOrder/RequestOrder";
import { CUSTOMER, SELLABLE_PRODUCT } from "../../config/constants";
import { userIsAuthenticated } from "../../stateManagement/helpers";
import {
  IAuthState,
  IUser,
  resetLoggedOut,
  tryConfirmLogin,
} from "../../stateManagement/reducers/authReducer";
import {
  closeCart,
  ICartState,
  openCart,
} from "../../stateManagement/reducers/cartReducer";
import { tryFetchActiveMembership } from "../../stateManagement/reducers/ordersReducer";
import {
  IRentalItem,
  IRentalItemsState,
  setFavouriteRentalItems,
} from "../../stateManagement/reducers/rentalItemsReducer";
import { IRootReducerT } from "../../stateManagement/reduxStore";
import Background from "./Background";
import Header from "./components/Header";
import ServiceDetails from "./components/ServiceDetails";

const GeneralLayout = () => {
  const dispatch = useDispatch<any>();
  const { user, authToken, realRole, loggedOut } = useSelector<
    IRootReducerT,
    IAuthState
  >((state) => state.auth);
  const location = useLocation();
  const [favItems, setFavItems] = useState<IRentalItem[]>([]);

  const { isCartOpen } = useSelector<IRootReducerT, ICartState>(
    (state) => state.cart,
  );
  const { mainRentalItem } = useSelector<IRootReducerT, IRentalItemsState>(
    (state) => state.rentalItems,
  );

  const [show, setShow] = useState(false);

  const [showRentalOrderRequestForm, setShowRentalOrderRequestForm] =
    useState(false);

  const [isInitRender, setIsInitRender] = useState(true);
  useEffect(() => {
    if (isInitRender) {
      setIsInitRender(false);
      return;
    }

    setShow(false);
  }, [isInitRender, location.pathname]);

  useEffect(() => {
    if (!show) {
      setTimeout(() => {
        setShow(true);
      }, 100);
    }
  }, [show]);

  useEffect(() => {
    if (user?.role && realRole && user.role.name !== realRole.name) {
      return;
    }

    if (user && user?.role?.name === CUSTOMER) {
      dispatch(tryFetchActiveMembership({ authToken: authToken ?? "" }));

      if (userIsAuthenticated(user as IUser)) {
      }
    }
  }, [user]);

  useEffect(() => {
    if (user?.role && realRole && user.role.name !== realRole.name) {
      return;
    }

    dispatch(
      tryConfirmLogin({
        authToken: authToken ?? "",
        setFavouriteRentalItems: setFavItems,
      }),
    );
  }, []);

  useEffect(() => {
    if (favItems.length > 0) {
      dispatch(setFavouriteRentalItems(favItems));
    }
  }, [favItems]);

  const [isInitRender120, setIsInitRender120] = useState(true);
  useEffect(() => {
    if (isInitRender120) {
      setIsInitRender120(false);
      dispatch(resetLoggedOut({ authToken: authToken ?? "" }));
      return;
    }
  }, [loggedOut]);

  const [showCartModal, setShowCartModal] = useState(false);
  const [closeCartModal, setCloseCartModal] = useState(true);

  const setIsCartOpen = (truth: boolean) => {
    truth ? dispatch(openCart()) : dispatch(closeCart());
  };

  useEffect(() => {
    if (showCartModal) {
      setCloseCartModal(false);
    } else {
      setTimeout(() => setCloseCartModal(true), 500);
    }
  }, [showCartModal]);

  useEffect(() => {
    if (isCartOpen) {
      setShowCartModal(true);
      setCloseCartModal(false);
    } else {
      setShowCartModal(false);
      setTimeout(() => setCloseCartModal(true), 500);
    }
  }, [isCartOpen]);

  return (
    <>
      <Stack
        id="generalBody"
        alignItems="center"
        width={"100%"}
        spacing={4}
        sx={{
          display: "flex",
          backgroundColor: "#F5F0E6",
          position: "relative",
          overflow: "hidden",
          minHeight: "100vh",
          p: 0,
          pt: 0,
          pb: 0,
        }}
      >
        <Aos />
        <Header setShowCartModal={setIsCartOpen} />
        <Fade
          in={show}
          style={{
            transitionDelay: show ? "250ms" : "0ms",
            transitionDuration: "500ms",
          }}
        >
          <Box
            component="main"
            sx={{
              flexGrow: 1,
              p: {
                xs: 0,
                sm: 0,
              },
              position: "relative",
              pb: "0 !important",
              display: "flex",
              width: "100%",
              minHeight: {
                xs: "80vh",
                md: "100vh",
              },
              marginTop: "0 !important",
              overflow: "hidden",
            }}
          >
            <Background />
            <div className="w-full h-full fixed top-0 left-0 z-0 opacity-[.2]">
              <img
                src={require("../../assets/images/jewelries.png")}
                alt="Bread 4"
                className="object-cover w-full h-full"
              />
            </div>

            {show && <Outlet />}
          </Box>
        </Fade>
        <Footer />
      </Stack>
      {!closeCartModal && (
        <CartModal
          isModalOpen={showCartModal}
          openModal={setIsCartOpen}
          showOrderPlacementModal={() => {
            setShowRentalOrderRequestForm(true);
          }}
        />
      )}
      {mainRentalItem?.type === SELLABLE_PRODUCT && (
        <ServiceDetails rentalItem={mainRentalItem} />
      )}
      {user && (
        <PopUp
          id="customerRequestRentalOrderRequest"
          deployed={showRentalOrderRequestForm}
          setDeployed={setShowRentalOrderRequestForm}
        >
          <RequestOrder
            user={user as IUser}
            setOpened={setShowRentalOrderRequestForm}
          />
        </PopUp>
      )}
    </>
  );
};

export default GeneralLayout;
